import {
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
} from "@mui/material";
import Iconify from "src/components/Iconify";
import Translate from "src/components/translate";

const Actions = ({
  selectedId,
  membersList,
  OpenChangeStatus,
}) => {
  const member = membersList?.find((m) => m.id === selectedId);

  return (
    <>
      <MenuItem
        sx={{ color: "default.main" }}
        onClick={OpenChangeStatus}
        name="change-status"
      >
        <Iconify icon={"mdi:list-status"} />
        <Translate>{"consultation.change_status"}</Translate>
      </MenuItem>
    </>
  );
};

export default Actions;
